var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-grow-1 p-2"},[_c('TranslationsManager',{attrs:{"value":_vm.value,"empty-state-title":"Dit product heeft geen vertalingen"},on:{"input":function (newVal) { return _vm.$emit('input', newVal); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }